import { SET_IS_PDP_RESP_PREVIEW_PAGE } from '../actions/pdpRespPreviewPageActions';

const initialState = { isPdpRespPreviewPage: false };

export function pdpRespPreviewPageReducer(state, action) {
    switch (action.type) {
        case SET_IS_PDP_RESP_PREVIEW_PAGE:
            return {
                ...state,
                isPdpRespPreviewPage: action.isPdpRespPreviewPage,
            };
    }

    return state || initialState;
}

export default pdpRespPreviewPageReducer;
